import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { SpotActivityTable } from './components/SpotActivityTable';
import { SpotModalityTable } from './components/SpotModalityTable';

export const SpotDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          <Tab>Calendars</Tab>

          <Tab>Modalidades</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <SpotActivityTable />
          </TabPanel>

          <TabPanel>
            <SpotModalityTable />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
